import api, { apiSetup } from '../api';

apiSetup();

export class SectorsService {
  BASE_URL = '/sectors';

  get() {
    return api.get(this.BASE_URL);
  }
}
